import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "nav-daily-check-in__label"
};
import { useDailyCheckInUi } from '@/composables/useDailyCheckInUi';
export default {
  __name: 'NavDailyCheckInEntry',
  setup(__props) {
    const {
      openDialog,
      checkedInToday
    } = useDailyCheckInUi();
    function onClick() {
      openDialog();
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("button", {
        type: "button",
        class: "nav-daily-check-in",
        "aria-label": _ctx.$t(_unref(checkedInToday) ? 'dailyCheckIn.checkedIn' : 'nav.dailyCheckInAria'),
        onClick: onClick
      }, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "nav-daily-check-in__glow",
        "aria-hidden": "true"
      }, null, -1)), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "nav-daily-check-in__icon",
        "aria-hidden": "true"
      }, "✓", -1)), _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(_unref(checkedInToday) ? 'dailyCheckIn.checkedIn' : 'nav.dailyCheckInLabel')), 1)], 8, _hoisted_1);
    };
  }
};